import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import SuiLogo from "../../assets/icons/sui-sui-logo.svg";
import UserIdLogo from "../../assets/icons/user-id-logo.svg";
import ArrowDownLogo from "../../assets/icons/arrow-down.svg";
import FourHeadLogo from "../../assets/logos/fourhead-logo.svg";

interface BreadcrumbItem {
  label: string;
  path: string;
}

const TopNav: React.FC = () => {
  const location = useLocation();
  const [copied, setCopied] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Mock user data
  const userBalance = "10,000,056.4";
  const userAddress = "0xEcEB...c670";
  const fullAddress = "0xEcEBc4A9F8d8c670B8b4C5d6E7F8A9B0C1D2E3F4";

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(fullAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy address:", err);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const getBreadcrumbs = (pathname: string): BreadcrumbItem[] => {
    const pathSegments = pathname.split("/").filter((segment) => segment);

    //route mappings
    const routeMap: { [key: string]: string } = {
      "recent-stakes": "Recent Stakes",
      leaderboards: "Leaderboards",
      games: "Games",
      coinflip: "Coinflip",
      "panther-wheel": "Panther Wheel",
      "fourhead-order": "Fourhead Order",
      explore: "Explore",
      raffles: "Raffles",
      referrals: "Referrals",
      blog: "Blog",
      "become-creator": "Become a Creator",
      "help-support": "Help & Support",
    };

    const breadcrumbs: BreadcrumbItem[] = [{ label: "Home", path: "/" }];

    let currentPath = "";
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label =
        routeMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);

      breadcrumbs.push({
        label,
        path: currentPath,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(location.pathname);

  return (
    <div className="top-nav">
      <div className="top-nav__content">
        {/* Mobile Layout */}
        <div className="mobile-layout">
          {/* Mobile Logo */}
          <div className="mobile-logo">
            <img
              src={FourHeadLogo}
              alt="FourHead Logo"
              className="mobile-logo__icon"
            />
          </div>

          {/* Mobile User Info with Dropdown */}
          <div className="mobile-user-info">
            <div className="mobile-balance-dropdown">
              <div className="user-info__balance" onClick={toggleDropdown}>
                <span className="user-info__balance-amount">{userBalance}</span>
                <img
                  src={SuiLogo}
                  alt="SUI Logo"
                  className="user-info__balance-icon"
                />
                <img
                  src={ArrowDownLogo}
                  alt="Arrow Down"
                  className={`mobile-dropdown-arrow ${
                    isDropdownOpen ? "open" : ""
                  }`}
                />
              </div>

              {isDropdownOpen && (
                <div className="mobile-address-dropdown">
                  <div
                    className="user-info__address mobile-address"
                    onClick={handleCopyAddress}
                    title={copied ? "Copied!" : "Click to copy full address"}
                  >
                    <img
                      src={UserIdLogo}
                      alt="User ID"
                      className="user-info__address-icon"
                    />
                    <span className="user-info__address-text">
                      {copied ? "Copied!" : userAddress}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="desktop-layout">
          {/* Desktop Breadcrumbs */}
          <nav className="breadcrumbs">
            {breadcrumbs.map((crumb, index) => (
              <span key={crumb.path} className="breadcrumbs__item">
                <span
                  className={`breadcrumbs__link ${
                    index === breadcrumbs.length - 1 ? "active" : ""
                  }`}
                >
                  {crumb.label}
                </span>
                {index < breadcrumbs.length - 1 && (
                  <span className="breadcrumbs__separator">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="breadcrumbs__arrow"
                    >
                      <path
                        d="M6 4L10 8L6 12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                )}
              </span>
            ))}
          </nav>

          {/* Desktop User Info */}
          <div className="user-info">
            <div className="user-info__balance">
              <span className="user-info__balance-amount">{userBalance}</span>
              <img
                src={SuiLogo}
                alt="SUI Logo"
                className="user-info__balance-icon"
              />
            </div>

            <div
              className="user-info__address"
              onClick={handleCopyAddress}
              title={copied ? "Copied!" : "Click to copy full address"}
            >
              <img
                src={UserIdLogo}
                alt="User ID"
                className="user-info__address-icon"
              />
              <span className="user-info__address-text">
                {copied ? "Copied!" : userAddress}
              </span>
              <img
                src={ArrowDownLogo}
                alt="Arrow Down"
                className="user-info__address-arrow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
